export default {
      id: "ar-plan-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-plan-usage",
      toString: function () {
        return this.url;
      }
    }